/* eslint-disable no-shadow */
import React from 'react';
import { Formik } from 'formik';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { GET_USER_KYC, UPDATE_USER_KYC } from 'utils/CommonGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import Loader from 'components/common/Loader';
import VendorForeignKycForm from './components/VendorForeignKycForm';

const VendorForeignKyc = ({ id, onTimelineRefresh = () => {} }) => {
  const { data, loading, error, refetch } = useQuery(GET_USER_KYC, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  const [updateUserKYC] = useMutation(UPDATE_USER_KYC, {
    onCompleted: ({ updateUserKYC }) => {
      toast.success(updateUserKYC);
      refetch();
      onTimelineRefresh();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
    },
  });
  // const [updateCompanyFormationDocumentForUser] = useMutation(
  //   UPDATE_FOREIGN_USER_KYC,
  //   {
  //     onCompleted: ({ updateCompanyFormationDocumentForUser }) => {
  //       toast.success(updateCompanyFormationDocumentForUser);
  //       refetch();
  //     },
  //     onError: ({ graphQLErrors }) => {
  //       graphQLErrors.forEach(({ message }) => {
  //         toast.error(message);
  //       });
  //     },
  //   }
  // );
  const handleSubmit = async (values) => {
    await updateUserKYC({
      variables: {
        input: {
          ...values,
          companyFormationDocument: values?.companyFormationDocument?.length
            ? values?.companyFormationDocument
            : null,
          companyFormationDocumentStatus: values?.companyFormationDocument
            ?.length
            ? 'completed'
            : 'pending',
          foreignIdVerificationDocument: values?.foreignIdVerificationDocument
            ?.length
            ? values?.foreignIdVerificationDocument
            : null,
          foreignIdVerificationDocumentStatus: values
            ?.foreignIdVerificationDocument?.length
            ? 'completed'
            : 'pending',
          userVerificationDocument: values?.userVerificationDocument?.length
            ? values?.userVerificationDocument
            : null,
          userVerificationDocumentStatus: values?.foreignIdVerificationDocument
            ?.length
            ? 'completed'
            : 'pending',
        },
      },
    });
    // drawerToggle();
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.userKYC) return 'User KYC not available';

  return (
    <ErrorBoundary>
      <Formik
        initialValues={{
          id: data?.userKYC?.id,
          companyFormationDocument: data?.userKYC?.companyFormationDocument
            ? data?.userKYC?.companyFormationDocument
            : '',
          companyFormationDocumentStatus:
            data?.userKYC?.companyFormationDocumentStatus,
          foreignIdVerificationDocument: data?.userKYC
            ?.foreignIdVerificationDocument
            ? data?.userKYC?.foreignIdVerificationDocument
            : '',
          foreignIdVerificationDocumentStatus:
            data?.userKYC?.foreignIdVerificationDocumentStatus,
          userVerificationDocument: data?.userKYC?.userVerificationDocument
            ? data?.userKYC?.userVerificationDocument
            : '',
          userVerificationDocumentStatus:
            data?.userKYC?.userVerificationDocumentStatus,
          kycStatus: null,
        }}
        enableReinitialize
        // validationSchema={foreignVendorKYCSchema}
        onSubmit={handleSubmit}
        children={(props) => {
          return <VendorForeignKycForm {...props} />;
        }}
      />
    </ErrorBoundary>
  );
};

export default VendorForeignKyc;
